export enum ESectionTitle {
  SIVI = 'sivi',
  SITA = 'sita',
  ATRC = 'atrc'
}
